import axios from 'axios'
import qs from 'qs'
import { Message} from 'element-ui';
axios.defaults.timeout = 10000;
import store from '@/store'
import { data } from 'autoprefixer';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
let tokenObj = window.localStorage.getItem('TokenData');
if(tokenObj && tokenObj != 'null') {
  tokenObj = store.state.TokenData || JSON.parse(tokenObj);
  axios.defaults.headers.Authorization = tokenObj.token_type+ ' '+ tokenObj.access_token;
}
axios.interceptors.response.use(
	response => {
    console.log(response.data.Code)
		if(response.status == 200 && response.data.Code && response.data.Code != 200){
      Message.error(response.data.Msg)
    }
		return response
	},
	error => {
		console.log(error)
		return Promise.reject(error)
	}
)
export default {
  fetchGet (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost (url, params={}, header) {
    if(header && header != 'formData'){
      axios.defaults.headers['Content-Type'] = "application/x-www-form-urlencoded";
      params = qs.stringify(params)
    } else if (header && header == 'formData') {
      axios.defaults.headers['Content-Type'] = "multipart/form-data";
    } else {
      axios.defaults.headers['Content-Type'] = 'application/json';
    }
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js